<h2 class="is-font-h2 is-font-bold mt-0">{{ data?.label }}</h2>

@if (data?.fields) {
<div class="list-details-item-column">
    @for (item of data.fields; track item) { @if (item.value) {
    <div class="mb-2" [class]="item.class">
        <h3 class="is-color-opacity-secondary mr-1 item-label">
            {{ item.label }}
        </h3>
        <span class="is-font-500">
            {{ item.value }}
        </span>
    </div>
    } }
</div>
} @else {
<div class="is-color-opacity-secondary" [innerHTML]="data.value"></div>
}
